import React, { useContext, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { Column } from '@ant-design/plots';
import CustomCard from '@components/CustomCard';
import SessionContext from '@providers/Session/SessionContext';

export const ChartComponent = ({
  dataChart,
  formatLabels,
  setSearchParams,
  title,
  color,
  field,
}: any) => {
  const { t: translate } = useTranslation('roaming');
  const { theme } = useContext(SessionContext);

  const dataFormat = useMemo(() => dataChart, [dataChart]);

  return (
    <CustomCard title={translate(title)}>
      <Column
        data={dataFormat}
        xField="key"
        yField="value"
        autoFit
        style={{ padding: 0 }}
        label={{
          position: 'top',
          style: {
            fill: theme?.colors?.text1,
          },
          content: (contentData: any) => formatLabels(contentData.value),
        }}
        xAxis={{
          label: {
            autoHide: true,
            autoRotate: false,
          },
        }}
        columnStyle={{
          radius: [6, 6, 0, 0],
        }}
        height={300}
        meta={{
          key: {
            alias: translate('table.telephone'),
          },
        }}
        legend={false}
        seriesField="key"
        color={color}
        onReady={plot => {
          plot.on('plot:click', (evt: any) => {
            const { x, y } = evt;
            const tooltipData = plot.chart.getTooltipItems({ x, y });
            setSearchParams({
              [field]: tooltipData[0].title,
            });
          });
          plot.update({
            autoFit: true,
          });
        }}
      />
    </CustomCard>
  );
};
